import { Button as AntButton } from 'antd';
import PropTypes from 'prop-types';

export const Button = ({ type, size, isLoading, label, isDisabled, ...props }) => {
  return (
    <AntButton type={type} size={size} loading={isLoading} disabled={isDisabled} {...props}>
      {label}
    </AntButton>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf(['primary', 'default', 'dashed', 'text', 'link']),
  size: PropTypes.oneOf(['large', 'default', 'small']),
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  type: 'primary',
  size: 'default',
  isLoading: false,
  disabled: false,
};
